import RatingsApi from '../api/RatingsApi';
import RatingsConstants from '../constants/RatingsConstants';
import { selectCurrentUser } from '../selectors/AuthSelector';
import composeGlobalSuccessMessaging from '../helpers/messaging/composeGlobalSuccessMessaging';
import composeUgcSuccessMessaging from '../helpers/messaging/composeUgcSuccessMessaging';

/**
 * Gets the item rating for ONE bib
 * @param {String}  metadataId Bib to retrieve rating for
 */
function getItemRatings(metadataIds) {
  return {
    metadataIds,
    types: [
      RatingsConstants.GET_ITEM_RATING_REQUEST,
      RatingsConstants.GET_ITEM_RATING_SUCCESS,
      RatingsConstants.GET_ITEM_RATING_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      RatingsApi.getItemRatings(
        {
          metadataIds,
          userId: selectCurrentUser(state).get('id')
        },
        client
      )
  };
}

/**
 * Rates ONE bib
 * @param {String}  metadataId Bib to rate
 * @param {Integer} rating Rating value, from 0 to 100
 */
function rateItem(metadataId, rating, ui) {
  return {
    metadataIds: [metadataId],
    ui,
    types: [RatingsConstants.RATE_ITEM_REQUEST, RatingsConstants.RATE_ITEM_SUCCESS, RatingsConstants.RATE_ITEM_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      RatingsApi.rateItem(
        {
          metadataId,
          rating,
          userId: selectCurrentUser(state).get('id')
        },
        client
      ),
    apiSuccess: (response, store) => ({
      messaging: composeUgcSuccessMessaging({
        response,
        store,
        metadataId,
        type: 'rating'
      })
    })
  };
}

/**
 * Changes the rating of ONE bib
 * @param {String}  metadataId Bib to rate
 * @param {Integer} rating Rating value, from 0 to 100
 */
function changeItemRating(metadataId, rating) {
  return {
    metadataIds: [metadataId],
    types: [
      RatingsConstants.CHANGE_ITEM_RATING_REQUEST,
      RatingsConstants.CHANGE_ITEM_RATING_SUCCESS,
      RatingsConstants.CHANGE_ITEM_RATING_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      RatingsApi.changeItemRating(
        {
          metadataId,
          rating,
          userId: selectCurrentUser(state).get('id')
        },
        client
      ),
    apiSuccess: () => ({
      messaging: composeUgcSuccessMessaging({ metadataId, type: 'rating', updated: true })
    })
  };
}

/**
 * Removes the rating for ONE bib
 * @param {String}  metadataId Bib with rating to remove
 */
function removeItemRating(metadataId, ratingId) {
  return {
    metadataIds: [metadataId],
    types: [
      RatingsConstants.REMOVE_ITEM_RATING_REQUEST,
      RatingsConstants.REMOVE_ITEM_RATING_SUCCESS,
      RatingsConstants.REMOVE_ITEM_RATING_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      RatingsApi.removeItemRating(
        {
          metadataId,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      ),
    apiSuccess: () => ({
      messaging: composeGlobalSuccessMessaging('success_rating_clear_message'),
      deletedEntities: [`ugc.ratings.${ratingId}`]
    })
  };
}

export default {
  getItemRatings,
  rateItem,
  changeItemRating,
  removeItemRating
};
